<template>
  <div class="device_screen_config">
    <div class="border_title">
      {{ $t('deviceMsg.screenSetting') }}
    </div>
    <div class="device_screen_config_container">
      <div class="left_container">
        <img :src="defalutBigIcon">
      </div>
      <div class="right_container">
        <div class="right_container_top">
          <span>{{ $t('deviceMsg.defaultScreen') }}</span>
          <div class="icon_list">
            <div
              v-for="(item, index) in defaultRelationsList"
              v-if="item.show"
              :key="index"
              class="icon_item_div"
            >
              <div class="icon">
                <div class="imgDiv">
                  <img :src="item.icon">
                </div>
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="right_container_bottom">
          <div class="header">
            <span class="config_title">{{ $t('deviceMsg.screenSetting') }}<span class="config_des">{{ maxSettingTips }}</span></span>
            <img src="../../assets/img/screenEdit.png" @click="clickEdit">
          </div>
          <div v-loading="loading" class="icon_list">
            <Vuedraggable
              v-model="deviceCardList"
              group="people"
              class="draggable"
              animation="1000"
              :disabled="!edit"
              @change="change"
              @start="start"
              @end="end"
            >
              <div
                v-for="(item, index) in deviceCardList"
                :key="index"
                class="icon_item_div"
                :draggable="false"
              >
                <div class="icon">
                  <div class="imgDiv">
                    <img :src="item.iconImg" :draggable="false">
                  </div>
                  <div v-if="edit" class="del_icon">
                    <img src="../../assets/img/delScreen.png" @click="deleteDevice(item, index)">
                  </div>
                </div>
                <span>{{ item.DeviceName || item.SceneName }}</span>
              </div>
              <el-popover
                v-if="showAdd()"
                placement="top"
                trigger="hover"
                popper-class="add_popover"
                :draggable="false"
              >
                <div slot="reference" class="icon_item" :draggable="false">
                  <img src="../../assets/img/screenAdd.png">
                  <span>{{ $t('scene.add') }}</span>
                </div>
                <div class="add_list">
                  <div
                    v-for="item in addList"
                    class="add_list_item"
                    :disable="item.disabled"
                    @click="add(item)"
                  >
                    <span>{{ item.name }}</span>
                  </div>
                </div>
              </el-popover>
            </Vuedraggable>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择设备弹出 -->
    <template v-if="showDeviceChoose">
      <el-dialog
        :visible="showDeviceChoose"
        class="dialogGroup choose_device"
        :before-close="handleClose"
        top="0"
        append-to-body
      >
        <op-device-choose
          v-if="showDeviceChoose"
          ref="opDeviceChoose"
          class="content"
          :is_group="false"
          :areaid="gpNo"
          :area-tree-type="1"
          :execute-type="2"
          :displaynoarea="true"
          :triggledevice="true"
          :is-ifttt="true"
          :checkeddata="checkeddata"
          :child-category-type="CatParamsStr"
          :only-compare-device="true"
          :class-skus="ClassSkus"
          :device-category-type="SubCatParams"
          :max-device="maxDevice"
          :has-select-device="hasSelectDevice"
          :required-max-device="true"
          :bind-status="1"
          @confirm="deviceValueChange"
        />
      </el-dialog>
    </template>
    <!-- 选择场景弹出 -->
    <template v-if="showIfttChoose">
      <el-dialog
        :visible.sync="showIfttChoose"
        class="dialogGroup IfttChoose deviceMsgIftt"
        :before-close="handleClose"
        append-to-body
      >
        <v-scence 
          :areaid="gpNo" 
          :already-check="allactionlist" 
          :nocall="true" 
          :isradio="false"
          :require-max-sence="true"
          :max-sence="maxScene"
          :has-select-sence="hasSelectSence"
          :filter-already-check="true" 
          @confirm="confirmScene"
        />
      </el-dialog>
    </template>
  </div>
</template>
<script>
import vScence from '@/components/common/scenceSelect.vue'
import { FindDeviceAndSceneListByCommandValue, GetClassskuList } from '@/axios/IMonitor.js'
import { SetConfigs } from '@/axios/IDevice.js'
import { getImgUrlState } from '@/utils/utils'
import Vuedraggable from 'vuedraggable'
import { jsToUTF8 } from '@/utils/utils.js'
import { alerterror } from '@/assets/js/common.js';
export default {
  components: {
    vScence,
    Vuedraggable,
  },
  props: {
    device: {
      type: Object,
      default: () => ({}),
    },
    // 关联设备限制
    relationLimit: {
      type: Object,
      default: () => ({}),
    },
    // 默认关联信息
    RelationScreen: {
      type: Object,
      default: () => {}, // 默认值
    },
    GpList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      addList: [
        {
          name: this.$t('iftttset.doscene'),
          id: 1,
          disabled: false,
        },
        {
          name: this.$t('iftttset.device'),
          id: 2,
          disabled: false,
        },
      ],
      showDeviceChoose: false, //显示设备选择弹窗
      showIfttChoose: false, //显示场景弹窗
      checkeddata: [],
      gpNo: -1,
      allactionlist: [],
      SubCatParams: '',
      CatParamsStr: '',
      MaxCount: '',
      deviceCardList: [],
      type: 1,
      edit: false, //是否编辑
      loading: false,
      LimitType: '',
      deviceMax: 0, //设备限制个数
      sceneMax: 0, // 场景限制个数
      defaultRelationsList: [],
      defalutBigIcon: '', //设备大图
      classSkuInfo: {},
      ClassSkus: '',
      ScreenSettingInfo: {},
      maxSettingTips: '',
      hasSelectDevice:0, //已选择设备
      hasSelectSence:0, //已选择场景
      maxDevice: 0, // 最多可以选择几个设备
      maxScene: 0, // 最多可以选择几个场景
    }
  },
  watch: {
    relationLimit: {
      handler() {
        this.handleLimit()
      },
      deep: true,
    },
  },
  mounted() {
    this.init()
    this.getClassSkuInfo()
  },
  methods: {
    init() {
      try {
       this.handleLimit()
        if (this.RelationScreen && this.RelationScreen.prefetchRelationScreen) {
          const { GpKeyId, GpNo } = this.RelationScreen.prefetchRelationScreen
          this.ScreenSettingInfo = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId) || {}
        }
        this.maxSettingTips = this.$t('deviceMsg.maxScreenSettingTips').replace('{{MaxCount}}', `${this.MaxCount}`)
      } catch (error) {
        console.log('....init error', error)
      }
      this.requestRelationDeviceList()
    },
    handleLimit(){
      if (this.relationLimit) {
          const { Max, LimitType, Items } = this.relationLimit
          this.LimitType = LimitType
          if (Items && Array.isArray(Items)) {
            Items.forEach(item => {
              const { Type, Sub } = item
              if (Type === 'Device' && Sub && Array.isArray(Sub) && Sub.length > 0) {
                const { SubCat, Cat, Max, ClassSkus } = Sub[0]
                this.SubCatParams = SubCat.join(',')
                this.CatParamsStr = Cat.join(',')
                this.deviceMax = Max
                this.ClassSkus = ClassSkus.join(',')
              }
              if (Type === 'Scene') {
                const { Max } = item
                this.sceneMax = Max
              }
            })
          }
          if (LimitType === 'All') {
            this.MaxCount = Max
            this.maxDevice = Max
            this.maxScene = Max
          } else {
            this.MaxCount = this.deviceMax + this.sceneMax
            this.maxDevice = this.deviceMax
            this.maxScene = this.sceneMax
          }
        }
    },
    /**
     * 获取classsku信息
     */
    async getClassSkuInfo() {
      try {
        const res = await GetClassskuList()
        if (res.StatusCode != this.$store.state.rightStatusCode) {
          alerterror(this, res.StatusCode);
          return
        }
        if (this.RelationScreen) {
          this.defalutBigIcon = this.RelationScreen?.image || require('../../assets/img/screenDefault.png')
          const list = this.RelationScreen?.defaultRelations || []
          this.defaultRelationsList = list.map(item => {
            return {
              ...item,
              show: item.type === 'Default',
            }
          })
        }
        const result = res.Result || []
        this.classSkuInfo = {}
        result.forEach(item => {
          this.classSkuInfo[item.ClassSku] = item
        })
        if (this.defaultRelationsList) {
          this.defaultRelationsList.forEach(item => {
            const { type, sku } = item
            if (type === 'Config' && sku) {
              this.getRelationSku(item)
            }
          })
        }
      } catch (e) {
        console.log('....获取classsku信息错误', e)
      }
    },

    /**
     * 去获取关联的classsku
     */
    async getRelationSku(item) {
      try {
        console.log('......取关联的classsku')
        const { sku } = item
        const { GpNo, GpKeyId } = sku
        const info = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
        if (info) {
          const { DefaultValue } = info
          const DefaultValue_ = parseInt(DefaultValue)
          if (DefaultValue_ != 0) {
            const classSku = '0x' + DefaultValue
            const info_ = this.classSkuInfo[classSku]
            if (info_) {
              item.name = info_.Name
              let icon = ''
              if (this.$store.state.isLocalServer) {
                icon = getClassSkuImage(info_, 'on')
              } else {
                icon = getImgUrlState(info_, 'on')
              }
              item.icon = icon
              item.show = true
            }
          }
        }
      } catch (error) {}
    },
    /**
     * 获取关联设备列表
     */
    async requestRelationDeviceList() {
      try {
        //不能为空,为空时接口报错
        if(!this.ScreenSettingInfo.DefaultValue) return
        this.loading = true
        const res = await FindDeviceAndSceneListByCommandValue({
          VDeviceId: this.device.VDeviceId,
          CommandValue: this.ScreenSettingInfo.DefaultValue,
        })
        this.loading = false
        if (res.StatusCode != this.$store.state.rightStatusCode) {
          alerterror(this, res.StatusCode);
          return
        }
        const result = res.Result || []
        this.handleSuccessList(result)
      } catch (e) {
        console.log('....获取关联设备列表错误', e)
        this.loading = false
      }
    },
    /**
     * 获取场景icon
     * @param {*} msg
     */
    getSceneIcon(msg) {
      const { SceneType, ShowEntry } = msg
      if (SceneType == 0) {
        return require('../../assets/img/sun1.png')
      } else if (SceneType == 1) {
        return ShowEntry == 4 ? require('../../assets/img/tianmu.png') : require('../../assets/img/moon.png')
      } else if (SceneType == 2) {
        return require('../../assets/img/bei.png')
      } else if (SceneType === 3) {
        return require('../../assets/img/clear.png')
      } else if (SceneType === 4) {
        return require('../../assets/img/tan.png')
      } else if (SceneType === 5) {
        return require('../../assets/img/stop.png')
      } else {
        return require('../../assets/img/sun1.png')
      }
    },
    /**
     * 点击添加
     * @param {*} item
     */
    add(item) {
      const { id, disabled } = item
      if (disabled) {
        return
      }
      if (id === 2) {
        this.showDeviceChoose = true
      } else {
        this.showIfttChoose = true
      }
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.showDeviceChoose = false
      this.showIfttChoose = false
    },

    /**
     * 拼接字符串
     */
    handleUTF8(list) {
      try {
        let str = ''
        let all_length = 0
        list.forEach(item => {
          const { SceneNo, DeviceId, ClassSku, Mac, DeviceName } = item
          //场景
          if (SceneNo) {
            const linkType = jsToUTF8(1, 1)
            const id = jsToUTF8(+SceneNo, 4)
            const { hexString, byteLength } = jsToUTF8(item.SceneName || item.RuleName, 21, true)
            const nameLength = jsToUTF8(+byteLength, 1)
            const name = hexString
            const str1 = linkType + id + nameLength + name
            str += str1
            console.log('.......场景', str1)
            all_length += 6 + byteLength
          }
          if (DeviceId) {
            const linkType = jsToUTF8(0, 1)
            let ProtocolType = ''
            if (item.ProtocolTypeList && Array.isArray(item.ProtocolTypeList) && item.ProtocolTypeList.length > 0) {
              ProtocolType = item.ProtocolTypeList[0]?.Id
              ProtocolType = jsToUTF8(+ProtocolType, 2)
            }
            const id = jsToUTF8(+DeviceId, 4)
            const classSku = jsToUTF8(ClassSku, 4, false, false)
            const mac = jsToUTF8(Mac, 6, false, false)
            let deviceType = ''
            if (item.DeviceTypeList && Array.isArray(item.DeviceTypeList) && item.DeviceTypeList.length > 0) {
              let SubList = item.DeviceTypeList[0]?.SubList
              if (SubList && Array.isArray(SubList) && SubList.length > 0) {
                deviceType = SubList[0]?.Id
                deviceType = jsToUTF8(+deviceType, 4)
              }
            }
            const { hexString, byteLength } = jsToUTF8(DeviceName, 21, true)
            const nameLength = jsToUTF8(+byteLength, 1)
            const name = hexString
            const str1 = linkType + ProtocolType + id + classSku + mac + deviceType + nameLength + name
            str += str1

            all_length += 22 + byteLength
          }
        })
        const all_length_str = jsToUTF8(all_length, 2)
        str = all_length_str + str
        return str
      } catch (error) {
        console.log('......error', error)
      }
    },
    /**
     * 关联设备或场景
     * @param {*} relativeDevices 参数
     */
    async bindDeviceOrScene(str, list) {
      try {
        this.loading = true
        const res = await SetConfigs({
          VDeviceId: this.device.VDeviceId,
          GpNo: this.gpNo,
          ConfigItems: [{ Key: this.ScreenSettingInfo.KeyId, Values: [str] }],
        })
        this.loading = false
        if (res.StatusCode != this.$store.state.rightStatusCode) {
          alerterror(this, res.StatusCode);
        }
        this.handleClose()
        this.handleSuccessList(list)
      } catch (e) {
        this.loading = false
        this.$message({
          type: 'warning',
          message: e.Message,
        })
      }
    },
    /**
     * 处理下发接口成功后接口
     */
    handleSuccessList(list) {
      this.deviceCardList = []
      this.allactionlist = []
      this.checkeddata = [Object.assign({}, this.device)]
      list.forEach(item => {
        const { Type } = item
        //设备
        if (Type === 'Device') {
          let iconImg = ''
          if (this.$store.state.isLocalServer) {
            iconImg = getClassSkuImage(item, 'on')
          } else {
            iconImg = getImgUrlState(item, 'on')
          }
          this.deviceCardList.push({
            ...item,
            isCheck: true,
            iconImg,
            people: 'cn',
          })
          this.checkeddata.push(item)
        }
        // 不选择这个设备本身 因为设备不能关联自己
        if (Type === 'Scene') {
          const sceneInfo = {
            ...item,
            isCheck: false,
            iconImg: this.getSceneIcon(item),
            people: 'cn',
            SceneNo: item.IFtttId || item.SceneNo,
            SceneName: item.RuleName || item.SceneName,
          }
          this.allactionlist.push(sceneInfo)
          this.deviceCardList.push(sceneInfo)
        }
      })
      // 限制添加按钮
      if (this.LimitType !== 'All') {
        if (this.deviceCardList.length - this.allactionlist.length >= this.deviceMax) {
          this.addList[1].disabled = true
        }
        if (this.allactionlist.length >= this.sceneMax) {
          this.addList[0].disabled = true
        }
        this.hasSelectDevice = this.deviceCardList.length - this.allactionlist.length
        this.hasSelectSence = this.allactionlist.length
      }else{
        this.hasSelectDevice = this.deviceCardList.length
        this.hasSelectSence = this.deviceCardList.length
      }
      console.log('......this.checkeddata', this.checkeddata)
    },
    /**
     * 选择完设备后弹窗回调
     * @param {*} data 选择的设备
     */
    async deviceValueChange(data) {
      console.log('......data', data)
      data.forEach(item => {
        item.Type = 'Device'
      })
      this.showDeviceChoose = false
      const list = this.deviceCardList.concat(data)
      const str = this.handleUTF8(list)
      this.bindDeviceOrScene(str, list)
    },
    /**
     * 选择完场景的回调
     * @param {*} data 选择的场景
     */
    confirmScene(data) {
      console.log('.....选择完场景的回调', data)
      this.showIfttChoose = false
      data.forEach(item => {
        item.Type = 'Scene'
      })
      const list = this.deviceCardList.concat(data)
      
      const str = this.handleUTF8(list)
      this.bindDeviceOrScene(str, list)
    },
    /**
     *  是否显示新增按钮
     */
    showAdd() {
      if (this.edit) {
        return false
      }
      if (this.MaxCount !== '' && this.deviceCardList.length >= this.MaxCount) {
        return false
      }
      return true
    },
    clickEdit() {
      console.log('......edit')
      this.edit = !this.edit
    },
    /**
     * 删除设备
     * @param {*} item
     */
    async deleteDevice(item, index) {
      let list = [...this.deviceCardList]
      list.splice(index, 1)
      const str = this.handleUTF8(list)
      this.bindDeviceOrScene(str, list)
    },
    change(info) {
      console.log('....change', info)
    },
    start(info) {
      console.log('....start', info)
    },
    async end(info) {
      let list = [...this.deviceCardList]
      const str = this.handleUTF8(list)
      this.bindDeviceOrScene(str, list)
    },
  },
}
</script>

<style lang="scss" scoped>
.device_screen_config {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }

  .device_screen_config_container {
    display: flex;
    width: 100%;
    padding: 19px 0px 0px 0px;
    border: 1px solid #e0e3e6;
    flex-direction: row;

    .left_container {
      border-right: 1px solid #e0e3e6;
      padding: 20px 46px 0px 31px;

      img {
        width: 135px;
        height: 135px;
      }
    }

    .right_container {
      padding: 20px 17px 11px 40px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .right_container_top {
      > span {
        font-weight: 600;
        font-size: 12px;
        color: #000000;
      }
    }

    .right_container_bottom {
      margin-top: 20px;

      .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .config_title {
          font-weight: 600;
          font-size: 12px;
          color: #000000;

          .config_des {
            font-size: 10px;
            color: #000000ff;
            opacity: 0.3;
          }
        }

        img {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
    }

    .icon_list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 20px;

      .draggable {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
      }

      .icon_item_div {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 14px;
        margin-bottom: 14px;

        .icon {
          width: 81px;
          height: 81px;
          border-radius: 50%;
          background-color: #000000;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .imgDiv {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 32px;
              height: 32px;
            }
          }

          .del_icon {
            position: absolute;
            right: 0;
            top: 0;

            img {
              width: 19px;
              height: 19px;
              cursor: pointer;
            }
          }
        }

        span {
          font-size: 11px;
          color: #000000;
          margin-top: 5px;
          display: inline-block;
          width: 81px;
          text-align: center;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .icon_item {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 81px;
          height: 81px;
        }

        span {
          font-size: 11px;
          color: #000000;
          margin-top: 5px;
          display: inline-block;
          width: 81px;
          text-align: center;
        }
      }

      .icon_item * {
        user-select: none;
        /* 禁止选中文本 */
        -webkit-user-drag: none;
        /* 禁止拖动 */
        -moz-user-drag: none;
        /* 兼容Firefox */
        -ms-user-drag: none;
        /* 兼容IE/Edge */
        user-drag: none;
        /* 标准属性 */
      }
    }
  }
}
</style>

<style>
.add_popover {
  padding: 0px !important;
  min-width: auto !important;
  margin-bottom: 8px !important;

  .add_list .add_list_item {
    height: 30px;
    padding-left: 10px;
    display: flex;
    padding-right: 24px;
    align-items: center;

    span {
      font-weight: 400;
      font-size: 12px;
      color: #000000;
    }
  }

  .add_list .add_list_item:hover {
    background: #e0e9f8;

    span {
      color: #074aac;
    }
  }
}

.deviceMsgIftt .el-dialog {
  margin-top: 0px !important;
}

.deviceMsgIftt .Group_right_header {
  position: relative;
  display: flex;
  flex-direction: row;
}

.deviceMsgIftt .ok_group {
  position: absolute !important;
  right: 0px !important;
  top: 0px !important;
  float: none;
}

.deviceMsgIftt .search_mt {
  position: relative;
}

.deviceMsgIftt .search_mt .el-input--medium {
  padding-right: 10px;
}

.deviceMsgIftt .search_mt .search_button {
  padding-right: 5px;
}
</style>
